import React, { useState } from "react";
import { submitReport } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

/**
 * "Report an issue" form used from the profile sidebar modal. Extracted from
 * BrandProfile.jsx so the modal payload can be reused elsewhere (e.g. an
 * inline report link on the sector page) without duplicating state.
 */
export default function InlineReportForm({ brandSlug, onDone }) {
  const { t } = useI18n();
  const [state, setState] = useState({ category_hint: "", description: "", link: "", email: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitReport({ brand_slug: brandSlug, ...state });
      toast.success(t.report_confirm);
      onDone();
    } finally { setLoading(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-3 text-sm">
      <p style={{ color: "var(--bp-text-secondary)" }}>{t.report_intro}</p>
      <div>
        <label className="text-xs uppercase tracking-widest">{t.report_field_item}</label>
        <Input value={state.category_hint} onChange={(e) => setState({ ...state, category_hint: e.target.value })} data-testid="report-item" />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest">{t.report_field_desc}</label>
        <Textarea required value={state.description} onChange={(e) => setState({ ...state, description: e.target.value })} data-testid="report-desc" />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest">{t.report_field_link}</label>
        <Input value={state.link} onChange={(e) => setState({ ...state, link: e.target.value })} data-testid="report-link" />
      </div>
      <div>
        <label className="text-xs uppercase tracking-widest">{t.report_field_email}</label>
        <Input type="email" value={state.email} onChange={(e) => setState({ ...state, email: e.target.value })} data-testid="report-email" />
      </div>
      <Button type="submit" disabled={loading} className="rounded-none w-full" data-testid="report-submit">{t.report_submit}</Button>
    </form>
  );
}
